<template>
    <div class="high-search">
        <Collapse simple value="1">
            <Panel name="1" hide-arrow>
                <div class="query-panel aFlex">
                    <img src="../assets/query-search.png">
                    <span style="color: #333333;margin-left: 5px">高级搜索</span>
                    <span class="query-arrow">
                    <img class="query-arrow-img" src="../assets/query-arrow.png">
                </span>
                </div>
                <div slot="content" class="query-panel-box">
                    <slot></slot>
                </div>
            </Panel>
        </Collapse>
    </div>
</template>
<style scoped>
    /* 高级搜索框 */
    .query-panel{
        /* border-bottom: 1px solid #DEDCE3; */
    }
    .query-panel-box{
        margin-top: 5px;
        border: 1px solid #ECECEC;
        box-shadow: #128EE8 2px 2px 8px;
        padding: 5px 25px 0 5px;
    }

    .high-search .query-arrow{
        margin-left: 30px;
    }
    .high-search .query-arrow:before{
        content: '展开';
        color: #DCC9C7;
        margin-right: 5px;
    }
    .high-search .query-arrow-img{
        transform:rotate(180deg);
    }

</style>
<style>
    .high-search .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header{
        padding-left: 0;
    }
    .high-search .ivu-collapse-content{
        padding: 0;
    }
    .high-search .ivu-collapse-item-active .query-arrow:before{
        content: '收起';
    }
    .high-search .ivu-collapse-item-active .query-arrow-img{
        transform:rotate(0deg);
    }
</style>
<script>
    export default {
        data(){
            return{

            };
        },
        props: {

        },
        mounted(){

        },

        watch: {

        },
        methods:{

        },
    };
</script>

